import type { UIMatch } from "react-router-dom";

import { can, resolveDefaultRoute } from "@/lib/permissions";
import { resolveDefaultProjectPath } from "@/pages/Project/projectNavConfig";
import type { Permission, User } from "@/types";
import type { AppRouteHandle, RouteSkeletonConfig } from "@/types/routeSkeleton";
import { SkeletonVariant } from "@/types/routeSkeleton";

export function getLeafRoutePermission(matches: UIMatch[]): Permission | undefined {
  for (let i = matches.length - 1; i >= 0; i -= 1) {
    const permission = (matches[i].handle as AppRouteHandle | undefined)?.permission;
    if (permission) return permission;
  }
  return undefined;
}

export function getLeafRouteSkeleton(matches: UIMatch[]): RouteSkeletonConfig {
  for (let i = matches.length - 1; i >= 0; i -= 1) {
    const skeleton = (matches[i].handle as AppRouteHandle | undefined)?.skeleton;
    if (skeleton) return skeleton;
  }
  return { skeletonVariant: SkeletonVariant.Shell };
}

export function resolvePermissionRedirect(
  user: User | null | undefined,
  projectId: string | undefined,
): string {
  if (projectId) {
    const fallback = resolveDefaultProjectPath(projectId, (p) => can(user, p));
    if (fallback !== "/projects") return fallback;
  }
  return resolveDefaultRoute(user);
}
